import { memo } from 'react';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import { ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { Element, Section, Title } from '@zmedia/bm-soccer-ui/components';
import { TeamFormList } from './list';
import styles from './style.module.scss';

export function TeamForm(props: any) {
    const { form } = props;

    if (ObjectUtils.isEmpty(form)) {
        return null;
    }
    const { home = {}, away = {} } = form;

    const homeMatches: IMatch[] = home.matches || [];
    const awayMatches: IMatch[] = away.matches || [];

    return (
        <Section className={styles['team-form-section']} name="match-team-form">
            <Title>Phong độ gần đây</Title>
            <Element className={styles['form-team-wrapper']}>
                <TeamFormList items={homeMatches} teamId={home.id} />
                <TeamFormList items={awayMatches} teamId={away.id} />
            </Element>
        </Section>
    );
}

export default memo(TeamForm);
